var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "shortcutComponent",
    {
      ref: "shortcutComponent",
      attrs: { showAddNew: false, modalClass: "ss-modal" },
      on: { "selection-item": _vm.onConfirm },
    },
    [
      _c("div", { attrs: { slot: "component" }, slot: "component" }, [
        _c("div", { staticClass: "col-sm-12" }, [
          _c(
            "div",
            [
              _c(
                "label",
                { staticClass: "control-label", attrs: { for: "etiquetas" } },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t(
                          "__.Crud.etiquetas.servicoCorreio_vue_html.etiqueta"
                        )
                      ) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("combo-component", {
                attrs: {
                  id: "etiqueta",
                  name: "etiqueta",
                  data: _vm.etiquetaOptions,
                },
                model: {
                  value: _vm.etiqueta,
                  callback: function ($$v) {
                    _vm.etiqueta = $$v
                  },
                  expression: "etiqueta",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }